import React from 'react';
import { Button, Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import './index.scss';

export const validateImageFile = (file, maxMiB) => {
  if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) return '仅支持 JPEG、PNG、WebP 图片';
  if (file.size > maxMiB * 1024 * 1024) return `图片不能超过 ${maxMiB} MB`;
  return '';
};
const ImagePicker = ({ files, onChange, maxCount = 9, maxMiB = 5, disabled = false, allowAdd = true }) => <div className="imagePicker">
  <p>JPEG、PNG、WebP，每张不超过 {maxMiB} MB，最多 {maxCount} 张</p>
  <Upload accept="image/jpeg,image/png,image/webp" listType="picture" multiple={maxCount > 1} disabled={disabled || maxCount <= 0} fileList={files} maxCount={Math.max(1, maxCount)}
    beforeUpload={file => {
      const error = validateImageFile(file, maxMiB);
      if (error) { message.error(error); return Upload.LIST_IGNORE; }
      return false;
    }} onChange={({ fileList }) => onChange(fileList.slice(-Math.max(1, maxCount)))}>
    {allowAdd && <Button icon={<UploadOutlined />} disabled={disabled || maxCount <= 0}>选择本地图片</Button>}
  </Upload>
</div>;
export default ImagePicker;
